import { render, staticRenderFns } from "./IntegralRule.vue?vue&type=template&id=e4605c7c&scoped=true"
import script from "./IntegralRule.vue?vue&type=script&lang=js"
export * from "./IntegralRule.vue?vue&type=script&lang=js"
import style0 from "./IntegralRule.vue?vue&type=style&index=0&id=e4605c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4605c7c",
  null
  
)

export default component.exports